module.exports = __webpack_public_path__ + "img/home_img_car_nor.6241da07.png";